/**
 * Sentry user identification for Release Health (Crash Free Users/Sessions).
 * @see https://docs.sentry.io/product/releases/health/
 */

import * as Sentry from '@sentry/nextjs';

const ANON_ID_KEY = 'hotlistcasino_anon_id';

function getOrCreateAnonymousId(): string {
  if (typeof window === 'undefined') return '';
  let id = window.localStorage.getItem(ANON_ID_KEY);
  if (!id) {
    id = `anon_${crypto.randomUUID()}`;
    window.localStorage.setItem(ANON_ID_KEY, id);
  }
  return id;
}

/**
 * Set Sentry user for authenticated profile. Enables Crash Free Users metrics.
 */
export function setSentryUser(profile: { email?: string | null; displayName?: string | null } | null): void {
  if (profile?.email) {
    Sentry.setUser({
      id: profile.email,
      email: profile.email,
      username: profile.displayName ?? undefined,
    });
  } else {
    setSentryAnonymousUser();
  }
}

/**
 * Set anonymous user for unauthenticated visitors. Enables user-level metrics.
 */
export function setSentryAnonymousUser(): void {
  const id = getOrCreateAnonymousId();
  Sentry.setUser(id ? { id } : null);
}

/**
 * Clear Sentry user (on logout). Falls back to anonymous ID.
 */
export function clearSentryUser(): void {
  setSentryAnonymousUser();
}
